import request from "@/utils/request";

export function download(url, params) {
  return request({
    method: "get",
    url: url,
    params,
    responseType: "blob"
  });
}
